import Styles from "./main.module.css";
import NotFoundImg from "../images/Lost-cuate.png";
export const ErrorNotAvailable = ( props ) => {
    const { image, headlines = [] } = props;
    const { ErrorNotAvailable } = Styles;
    return (
        <div className={ ErrorNotAvailable }>
            <h1><bdi>{ headlines[ Math.floor(Math.random() * headlines.length) ] }</bdi></h1>
            <div><img src={ image }/></div>
        </div>
    );
};
export const NotFound = ( props ) => {
    const { } = props;
    const { NotFound } = Styles;
    return (
        <div className={ NotFound }>
            <h1><bdi>🔍 404 - Page Not Found ⚠️</bdi></h1>
            <div><img src={ NotFoundImg }/></div>
            <p><bdi>🚫 Oops! The page you are looking for doesn't exist. 🌐</bdi></p>
            <p><bdi>Are you lost? 🤔! Return to the <a href="/"><i className="bi bi-house-door-fill"></i> Home page</a>.</bdi></p>
        </div>
    );
};